'use es6';

import http from 'hub-http/clients/apiClient';
const url = 'broadcast/v1/channels/setting/publish/current';
function fetch(userId) {
  return http.get(url, {
    query: {
      includeAccounts: false,
      userId
    }
  });
}
export default {
  fetch
};